import { Component } from '@angular/core';
import { COLUMNS_HEADER_PACKAGING_ADMIN } from '../../core/constants/tables.constants';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { ToastrService } from 'ngx-toastr';
import { PackagesService } from '../../core/services/packages.service';
import { BlendersService } from '../../core/services/blenders.service';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-packages',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, GenericTableComponent],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss'
})
export class PackagesComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_PACKAGING_ADMIN;

  packages: any;
  packagesFiltered: any;
  blenders: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;

  faSpinner = faSpinner;
  faMagnifyingGlass = faMagnifyingGlass;

  form: FormGroup = this.formBuilder.group({
    id: [, Validators.required],
    active: [, Validators.required],
    description: ['', Validators.required],
    time: [],

  });

  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return (obj.id?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.description?.toLowerCase().includes(this.filters.search.value.toLowerCase()) )
      }
    },
  };

  constructor(
    private packagesSvc: PackagesService,
    private formBuilder: FormBuilder,
    private blendersSvc: BlendersService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getBlenders();
    this.getPackages();
  }

  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getPackages();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`El envasado ${this.form.value.id} ha sido creado correctamente`);
        } else {
          this.toastr.success(`El envasado ${this.form.value.id} ha sido actualizado correctamente`);
        }
        this.form.reset();

      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      if (this.isCreating) {
        this.packagesSvc.createPackage(this.form.value).subscribe(responseAction);
      } else {
        this.packagesSvc.updatePackage(this.form.value).subscribe(responseAction);
      }
    }
  }

  getPackages() {
    this.packagesSvc.getPackages().subscribe((res: any) => {
      this.packages = [...res];
      this.packagesFiltered = res;
      this.isLoading = false;
    });
  }

  getBlenders() {
    this.blendersSvc.getBlenders().subscribe((res: any) => {
      this.blenders = res;
    });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    this.packagesSvc.deletePackage(item.id).subscribe({
      next: () => {
        this.getBlenders();
        this.getPackages();
        this.isLoading = false;
        this.toastr.success(`El envasado ${item.id} ha sido eliminado correctamente`);
      },
      error: () => {
        this.isLoading = false
      }
    })
  }

  onFilter() {
    this.packagesFiltered = this.packages.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
        this.filters[key] = '';
      }
    }
  }


}
